module.exports = __webpack_public_path__ + "static/media/playstore.1996ce19.svg";